import { clearSessionAcknowledged } from "./sessionGate";
import { clearCheckoutAuthToken } from "./checkoutSession";

export const SESSION_KEYS = ["idUsuario", "activeCourseId", "pendingOrderId", "borradorCurso", "carrito"];
export const CHECKOUT_CONSENT_SESSION_KEY = "checkout_consent_accepted";
export const CHECKOUT_CART_BACKUP_SESSION_KEY = "checkout_cart_backup";
export const CHECKOUT_OWNED_NOTICE_KEY = "checkout_owned_notice";

/** Removed from active use; cleared on logout to drop stale client-side bearer tokens. */
const LEGACY_AUTH_TOKEN_KEY = "authToken";

const LEGACY_SESSION_KEYS = [LEGACY_AUTH_TOKEN_KEY];

export function purgeLegacyAuthToken() {
  try {
    localStorage.removeItem(LEGACY_AUTH_TOKEN_KEY);
  } catch {
    /* ignore storage access errors */
  }
}

export function clearSessionKeys(options = {}) {
  const preserveCart = options?.preserveCart === true;
  SESSION_KEYS.forEach((key) => {
    if (preserveCart && key === "carrito") {
      return;
    }
    localStorage.removeItem(key);
  });
  LEGACY_SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem(CHECKOUT_CONSENT_SESSION_KEY);
  sessionStorage.removeItem(CHECKOUT_OWNED_NOTICE_KEY);
  clearCheckoutAuthToken();
  clearSessionAcknowledged();
}
